import api from '@/utils/api'

export default {
  namespaced: true,
  state: {
    favoritesCount: null,
    favoritesCountInterval: null,
  },
  getters: {
    favoritesCount(state) {
      return state.favoritesCount
    },
    favoritesCountInterval(state) {
      return state.favoritesCountInterval
    },
  },
  mutations: {
    setCount(state, count) {
      state.favoritesCount = count
    },
    setFavoritesCountInterval(state, interval) {
      state.favoritesCountInterval = interval
    },
    clearFavoritesCountInterval(state) {
      if (state.favoritesCountInterval) {
        clearInterval(state.favoritesCountInterval)
      }
    },
  },
  actions: {
    async addFavorite({ dispatch }, listingsId) {
      const { data: { favorite } } = await api.post('/favorites', {
        listingsId,
      })
      console.log(favorite, 'create favorite')
      dispatch('setFavoritesCount')
      return favorite
    },
    async removeFavorite({ dispatch }, favoritesId) {
      await api.delete(`/favorite/${favoritesId}`)
      dispatch('setFavoritesCount')
    },
    async enableFavoritesCountPolling({ commit, dispatch, getters }) {
      console.log('enable favorites polling')
      if (getters.favoritesCountInterval) {
        return
      }
      const interval = setInterval(() => {
        dispatch('setFavoritesCount')
      }, 5000)
      commit('setFavoritesCountInterval', interval)
    },
    async disableFavoritesCountPolling({ commit, getters }) {
      if (getters.favoritesCountInterval) {
        commit('clearFavoritesCountInterval')
      }
    },
    async setFavoritesCount({ commit, rootGetters }) {
      if (rootGetters['Authentication/isAuthenticated'] === false) {
        console.log('not logged in')
        return
      }
      try {
        const result = await api.get('/favorites/count')
        const { favoritesCount } = result.data
        commit('setCount', favoritesCount)
      } catch (err) {
        throw err
      }
    },
  },
}
